module.exports = __webpack_public_path__ + "static/img/8.5a90c42.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/8.png
// module id = l0Yd
// module chunks = 45